(function($) {

    var modalContactFormValid = true;
    var modalContactFormSubmit = $('.modal-contact-form-submit');
    var modalContactFormCall = $('.call-contact-modal');
    var modalContactFormRequiredFields = $('.modal-contact-form-wrap .required');

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    modalContactFormCall.on('click', function () {
        if ($('body').hasClass('single-zmones')) {
            $('.modal-contact-form-wrap input[name=contacted-person]').val($('.info-box h2').html())
        }
        $('.modal-contact').addClass('active');
        $('body').addClass('overflow-hidden');
    });

    modalContactFormSubmit.on('click', function () {
        modalContactFormSubmit.addClass('loading');

        modalContactFormValid = true;
        $('.modal-contact-form-wrap .input-wrap').removeClass('has-error');
        $('.modal-contact-form-wrap .input-wrap .input-error').hide();
        $('#modal-contact-agree').parent().removeClass('has-error');

        modalContactFormRequiredFields.each(function (ind, el) {

            if ($(el).attr('name') === 'contact-email') {
                if ($(el).val() === '') {
                    modalContactFormValid = false;
                    $(el).closest('.input-wrap').addClass('has-error').find('.input-error.contact-email-required').show();
                } else if (!validateEmail($(el).val())) {
                    modalContactFormValid = false;
                    $(el).closest('.input-wrap').addClass('has-error').find('.input-error.contact-email-incorrect').show();
                }
            } else {
                if ($(el).val() === '') {
                    modalContactFormValid = false;
                    $(el).closest('.input-wrap').addClass('has-error').find('.input-error').show();
                }
            }

            if (!$('#modal-contact-agree').is(':checked')) {
                modalContactFormValid = false;
                $('#modal-contact-agree').parent().addClass('has-error');
            }
        });

        if (modalContactFormValid) {

            $('.modal-contact-form-wrap input[type=submit]').click();

        } else {

            modalContactFormSubmit.removeClass('loading');

        }
    });

    $('.modal, .modal .close-modal').on('click', function (e) {
        if (e.target === this) {
            $('.modal').removeClass('active');
            $('body').removeClass('overflow-hidden');

            $('.modal-contact-form-success').hide();
            $('.modal-contact .contact-body').show();
        }
    });

    $(document).keydown(function(e) {
        if (e.keyCode === 27) {
            $('.modal').removeClass('active');
            $('body').removeClass('overflow-hidden');

            $('.modal-contact-form-success').hide();
            $('.modal-contact .contact-body').show();
        }
    });

})( jQuery );